@if (invoices.length > 0) {
    <div class="row">
        <div class="col-12">
            <div class="card">
                @if (showHeader) {
                    <div class="card-header">
                        <h3 class="card-title">Payment history</h3>
                        <div class="card-header-buttons">
                            <div class="dx-datagrid-export-button">
                                <button adaptButtonIcon="dx-icon dx-icon-xlsxfile"
                                        title="Export all data"
                                        (click)="exportAllData()"></button>
                            </div>
                            <div>
                                <button adaptButtonIcon="dx-icon dx-icon-column-chooser"
                                        title="Column Chooser"
                                        (click)="showColumnChooser()"
                                        [hidden]="!displayAdvancedOptions"></button>
                            </div>
                        </div>
                    </div>
                }
                <div class="card-body"
                     *adaptLoading="!organisation">
                    <dx-data-grid [dataSource]="invoices"
                                  [allowColumnReordering]="displayAdvancedOptions"
                                  [allowColumnResizing]="true"
                                  [columnAutoWidth]="true"
                                  [rowAlternationEnabled]="true">
                        <dxo-data-grid-paging [pageSize]="10"></dxo-data-grid-paging>
                        <dxo-data-grid-pager [showPageSizeSelector]="true"
                                             [allowedPageSizes]="[10, 25, 50, 100]"></dxo-data-grid-pager>
                        <dxo-data-grid-filter-row [visible]="displayAdvancedOptions"></dxo-data-grid-filter-row>
                        <dxo-data-grid-header-filter [visible]="true"></dxo-data-grid-header-filter>
                        <dxi-data-grid-column dataField="invoiceId"
                                              caption="InvoiceId"
                                              sortOrder="desc"
                                              [visible]="displayAdvancedOptions"
                                              alignment="left"></dxi-data-grid-column>
                        <dxi-data-grid-column dataField="invoiceString"
                                              caption="Invoice #"
                                              alignment="left"></dxi-data-grid-column>
                        <dxi-data-grid-column dataField="accountId"
                                              caption="Account Id"
                                              [visible]="false"
                                              alignment="left"></dxi-data-grid-column>
                        <dxi-data-grid-column dataField="date"
                                              caption="Date issued"
                                              [format]="dateFormat"
                                              alignment="left"></dxi-data-grid-column>
                        <dxi-data-grid-column dataField="periodStartDate"
                                              caption="Period Start"
                                              [format]="dateFormat"
                                              [visible]="displayAdvancedOptions"
                                              alignment="left"></dxi-data-grid-column>
                        <dxi-data-grid-column dataField="periodEndDate"
                                              caption="Period End"
                                              [format]="dateFormat"
                                              [visible]="displayAdvancedOptions"
                                              alignment="left"></dxi-data-grid-column>
                        <dxi-data-grid-column caption="Payment method"
                                              [visible]="displayAdvancedOptions"
                                              cellTemplate="paymentMethodCellTemplate"
                                              alignment="left"></dxi-data-grid-column>
                        <dxi-data-grid-column caption="Stripe Transaction Id"
                                              cellTemplate="transactionCellTemplate"
                                              [visible]="displayAdvancedOptions"
                                              alignment="left"></dxi-data-grid-column>
                        <dxi-data-grid-column dataField="type"
                                              [calculateCellValue]="calculateTypeCellValue"
                                              caption="Type"
                                              alignment="left"></dxi-data-grid-column>
                        <dxi-data-grid-column cellTemplate="statusCellTemplate"
                                              caption="Status"
                                              alignment="left"></dxi-data-grid-column>
                        <dxi-data-grid-column dataField="total"
                                              caption="Total due"
                                              format="currency"
                                              alignment="left"></dxi-data-grid-column>
                        <dxi-data-grid-column caption="Download"
                                              cellTemplate="downloadCellTemplate"
                                              fixedPosition="right"
                                              [allowReordering]="false"
                                              [allowHiding]="false"
                                              alignment="left"> </dxi-data-grid-column>
                        <div *dxTemplate="let item of 'downloadCellTemplate'">
                            @if (item.data.invoiceItems.length > 0) {
                                <button adaptButton="downloadLink"
                                        [adaptBlockingClick]="onClickExport"
                                        [adaptBlockingClickParam]="item.data"
                                        data-test="export-data-button"></button>
                            } @else {
                                <!-- This is only shown in nimbus as all lines with invalid invoices will be filtered out on cumulus -->
                                <span>N/A</span>
                            }
                        </div>
                        <div *dxTemplate="let item of 'paymentMethodCellTemplate'">
                            {{ getPaymentMethod(item.data.paymentMethod) }}
                        </div>
                        <div *dxTemplate="let item of 'transactionCellTemplate'">
                            {{ getTransactionId(item.data) }}
                        </div>
                        <div *dxTemplate="let item of 'statusCellTemplate'">
                            <div class="status badge"
                                 [ngClass]="{
                                    'bg-success': item.data.status === 'Paid',
                                    'bg-warning': item.data.status === 'Pending',
                                    'bg-danger': item.data.status === 'Unpaid',
                                    'bg-secondary': item.data.status === 'Archived',
                                }">
                                {{ item.data.status }}
                            </div>
                        </div>
                    </dx-data-grid>
                </div>
            </div>
        </div>
    </div>
}
